import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import DepositCss from '../css/DepositCss';
import { DepositDone } from '../Api/DepositDone';
import { Flip, toast } from 'react-toastify';
import { GetDeposit } from '../Api/GetDeposit';
import { Recharge } from '../Api/Recharge';
import { Helmet } from 'react-helmet'

export default function Deposit() {
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const { setLoad, setLoadColor, numberModal, sideBarOpen } = useContext(Context);

    const [amount, setAmount] = useState("");
    const [rechargeData, setRechargeData] = useState({});
    const [transactionId, setTransactionId] = useState("");
    const [depositData, setDepositData] = useState("");
    const handlePaymentDone = async () => {
        if (transactionId && amount) {
            setLoad(true);
            setLoadColor("#434343");

            const username = JSON.parse(localStorage.getItem('userinfo'))?.username;
            if (!username) return;

            const data = {
                username,
                amount: Number(amount),
                transaction_id: transactionId,
                payment_gateway: "upi-QR"
            };

            try {
                const res = await DepositDone(data);
                if (res?.data?.status) {
                    toast.success('Deposit Request Sent Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        theme: "colored",
                        transition: Flip,
                    });

                    try {
                        const res = await Recharge(rechargeData);
                        if (res?.data?.status) {
                            setDepositData(res.data.data);
                        } else {
                            toast.error(res.data.message || "Failed to fetch deposit data", {
                                position: "top-right",
                                autoClose: 1500,
                                theme: "colored",
                                transition: Flip,
                            });
                        }
                    } catch (error) {
                        toast.error("Something went wrong", {
                            position: "top-right",
                            autoClose: 1500,
                            theme: "colored",
                            transition: Flip,
                        });
                    }
                    // WhatsApp logic
                    const phone = process.env.REACT_APP_MOBILE_NO // Replace with target phone number
                    const message = `User ${username} submitted a deposit of ₹${amount} with Transaction ID: ${transactionId}`;
                    const encodedMessage = encodeURIComponent(message);
                    const whatsappUrl = `https://wa.me/${phone}?text=${encodedMessage}`;
                    window.open(whatsappUrl, "_blank");

                    navigate("/game");
                } else {
                    toast.error(res.data.message || "Failed to process deposit", {
                        position: "top-right",
                        autoClose: 1500,
                        theme: "colored",
                        transition: Flip,
                    });
                }
            } catch (error) {
                toast.error("Something went wrong", {
                    position: "top-right",
                    autoClose: 1500,
                    theme: "colored",
                    transition: Flip,
                });
            } finally {
                setLoad(false);
            }
        } else {
            toast.error("Fill the value first", {
                position: "top-right",
                autoClose: 1500,
                theme: "colored",
                transition: Flip,
            });
        }
    };

    const handleDeposit = useCallback(async () => {
        setLoad(true);
        setLoadColor("#434343");

        const username = JSON.parse(localStorage.getItem('userinfo'))?.username;
        if (!username) return;

        const data = {
            username,
            payment_gateway: "upi-QR"
        };

        try {
            const res = await GetDeposit(data);
            if (res?.data?.status) {
                setDepositData(res.data.data);
            } else {
                toast.error(res.data.message || "Failed to fetch deposit data", {
                    position: "top-right",
                    autoClose: 1500,
                    theme: "colored",
                    transition: Flip,
                });
            }
        } catch (error) {
            toast.error("Something went wrong", {
                position: "top-right",
                autoClose: 1500,
                theme: "colored",
                transition: Flip,
            });
        } finally {
            setLoad(false);
        }
    }, [setLoad, setLoadColor]);

    useEffect(() => {
        if (pathname === "/deposit/depositMoney" && !numberModal && !sideBarOpen) {
            if (location.state?.amount) {
                setAmount(location.state.amount.toString());
                setRechargeData(location.state.rechargeData)
            }
            handleDeposit();
        }
    }, [pathname, location.state, numberModal, sideBarOpen, handleDeposit]);

    const handleBack = () => {
        navigate('/game');
    };

    // const handlePaymentDone = async () => {
    //     if (transactionId && amount) {
    //         setLoad(true);
    //         setLoadColor("#434343");

    //         const username = JSON.parse(localStorage.getItem('userinfo'))?.username;
    //         if (!username) return;

    //         const data = {
    //             username,
    //             amount: Number(amount),
    //             transaction_id: transactionId,
    //             payment_gateway: "upi-QR"
    //         };

    //         try {
    //             const res = await DepositDone(data);
    //             if (res?.data?.status) {
    //                 toast.success('Deposit Request Sent Successfully', {
    //                     position: "top-right",
    //                     autoClose: 5000,
    //                     theme: "colored",
    //                     transition: Flip,
    //                 });
    //                 navigate("/game");
    //             } else {
    //                 toast.error(res.data.message || "Failed to process deposit", {
    //                     position: "top-right",
    //                     autoClose: 1500,
    //                     theme: "colored",
    //                     transition: Flip,
    //                 });
    //             }
    //         } catch (error) {
    //             toast.error("Something went wrong", {
    //                 position: "top-right",
    //                 autoClose: 1500,
    //                 theme: "colored",
    //                 transition: Flip,
    //             });
    //         } finally {
    //             setLoad(false);
    //         }
    //     } else {
    //         toast.error("Fill the value first", {
    //             position: "top-right",
    //             autoClose: 1500,
    //             theme: "colored",
    //             transition: Flip,
    //         });
    //     }
    // };

    return (
        <DepositCss>
            <Helmet>
                {/* Page Title */}
                <title>Deposit Funds | Secure Payment Gateway | Matka Jantri</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="Deposit funds securely to your MatkaJantri account using trusted payment methods. Fast and safe transactions for uninterrupted gameplay."
                />

                {/* SEO Directives */}
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://app.matkajantri.com/deposit" />

                {/* Favicon and Icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Deposit Funds | Secure Payment Gateway | MatkaJantri" />
                <meta
                    property="og:description"
                    content="Deposit funds securely to your MatkaJantri account using trusted payment methods. Fast and safe transactions for uninterrupted gameplay."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://app.matkajantri.com" />
                <meta property="og:image" content="https://app.matkajantri.com/Logo.png" />
                <meta name="google-site-verification" content="d6d81656210c6db7" />
            </Helmet>
            <div className="w-100 fullpage">
                <div className="w-3">
                    <div className="back-top" onClick={handleBack}>
                        <i className="fa-solid fa-chevron-left"></i>
                    </div>
                    <div className="w-100 text-ceter d-flex">
                        <button className="addFunds"><i className="fa-solid fa-wallet"></i> Recharge</button>
                    </div>
                    <div className="w-100 px-3">
                        <div className="mb-3 w-100">
                            <label className="form-label">Method</label>
                            <div className="position-relative">
                                <select className="form-control ps-3">
                                    <option>Phonepe</option>
                                    <option>GPay</option>
                                    <option>Paytm</option>
                                    <option>Other</option>

                                </select>
                            </div>
                        </div>
                        <div className="mb-3 w-100">
                            <label className="form-label">Amount (Min {depositData?.min_deposit})</label>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    className="form-control ps-4"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                />
                                {/* <img src="/img/ruppe.png" alt="" style={{ left: "4px" }} className="method-icon" /> */}
                            </div>
                        </div>
                        <div className="mb-3 w-100">
                            <label className="form-label">Transaction id/UTR</label>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    className="form-control ps-2"
                                    value={transactionId}
                                    onChange={(e) => setTransactionId(e.target.value)}
                                />
                            </div>
                        </div>

                        <label className="form-label">Instructions</label>
                        <div className="w-100 instructions-block">
                            <div className="step-text"><strong>Step 1: </strong>Take screenshot of QR code or scan QR</div>
                            <div className="step-text"><strong>Step 2: </strong>Enter amount and transaction Id of your payment</div>
                            <div className="step-text"><strong>Step 3: </strong>Submit it by clicking submit button</div>
                            <div className="d-flex" style={{ marginTop: "30px" }}>
                                <div className="qr-code">
                                    <img src={"https://app.matkajantri.com/QR.jpeg"} alt="QR Code" />
                                    <button className="scanandpay-btn">Scan Me</button>
                                </div>
                            </div>
                            <div className="text-ceter" onClick={handlePaymentDone}>
                                <button className="submit-btn">Submit</button>
                            </div>
                        </div>

                        <div className="text-ceter">
                            <button className="submit-btn support-btn">Support</button>
                        </div>
                    </div>
                </div>
            </div>
        </DepositCss>
    );
}
